module.exports = __webpack_public_path__ + "img/mark_face_front_image.81fdf1ec.svg";